import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  Checkbox,
  Dimmer,
  Form,
  Grid,
  Icon,
  Input,
  Image,
  Loader,
  Button,
  Modal,
  Popup,
  Table,
  TextArea,
} from "semantic-ui-react";
import "./index.css";
import MetaData from "../../components/MetaData";
import _debounce from "lodash/debounce";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import {
  apiAddNonBOAProduct,
  apiDeleteNonBOAProduct,
  apiGetNonBOAProduct,
  apiGetNonBOAProductsList,
  apiGetSyncWithXeroList,
  apiNonBOAProductDeleteFile,
  apiNonBOAProductUploadFile,
  apiSaveNonBOAProductsBulk,
  apiSyncWithXero,
  apiUpdateNonBOAProduct,
} from "./nonBOAItems.api";
import Papa from "papaparse";
import { nonBOAProductSearchDefaultOptions } from "./data";
import discountIcon from "../../assets/images/discount-icon.png";
import syncedXeroIcon from "../../../src/assets/images/synced_xero_icon.png";
import unsyncedXeroIcon from "../../../src/assets/images/unsynced_xero_icon.png";
import xeroRoundIcon from "../../../src/assets/images/xero_icon.png";
import boaRoundIcon from "../../../src/assets/images/boa_round_logo.png";
import exchangeIcon from "../../../src/assets/images/exchange_icon.png";
import Collapsible from "react-collapsible";
import { Checkbox as RoundCheckbox, TextareaAutosize } from "@mui/material";
import { styled } from "@mui/material/styles";
import { formatPrice } from "../../utils/utils";

export const animation = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.9 },
};

const NonBOAItems = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isImporting, setIsImporting] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchLoading, setSearchLoading] = useState(true);
  const [dataLoading, setDataLoading] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [nonBOAProductList, setNonBOAProductList] = useState([]);
  const [formData, setFormData] = useState({ statusId: 0 });
  const [addNonBOAItemOpen, setAddNonBOAItemOpen] = useState(false);
  const [openRemoveNonBOAProduct, setOpenRemoveNonBOAProduct] = useState(false);
  const [openDeleteNonBOAProduct, setOpenDeleteNonBOAProduct] = useState(false);
  const [selectedNonBOAProduct, setSelectedNonBOAProduct] = useState({});
  const [nonBOAProductSaved, setNonBOAProductSaved] = useState(false);
  const [nonBOAProducts, setNonBOAProducts] = useState([]);
  const [onNonBOAProductEdit, setOnNonBOAProductEdit] = useState(false);
  const [openRemoveContact, setOpenRemoveContact] = useState(false);
  const [selectedContact, setSelectedContact] = useState({});
  const [csvUploadOpen, setCsvUploadOpen] = useState(false);
  const [jsonResult, setJsonResult] = useState([]);
  const [jsonResultData, setJsonResultData] = useState([]);
  const [nonBOAProductsLoading, setNonBOAProductsLoading] = useState(false);
  const [nonBOAProductSearchOptions, setNonBOAProductSearchOptions] = useState(
    nonBOAProductSearchDefaultOptions
  );
  const [hasChanges, setHasChanges] = useState(false);
  const [hasBarcodeError, setHasBarcodeError] = useState(false);
  const [failedImports, setFailedImports] = useState([]);
  const [hasImportError, setHasImportError] = useState(false);

  // Upload file
  const [filesLoading, setFilesLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [deleteFileOpen, setDeleteFileOpen] = useState(false);
  const [selectedFile, setSelectefFile] = useState(null);

  // Sync with Xero
  const [syncWithXeroLoading, setSyncWithXeroLoading] = useState(false);
  const [syncWithXeroList, setSyncWithXeroList] = useState([]);
  const [toCreateList, setToCreateList] = useState([]);
  const [toUpdateList, setToUpdateList] = useState([]);
  const [syncWithXeroOpen, setSyncWithXeroOpen] = useState(false);
  const [syncToXeroOpen, setSyncToXeroOpen] = useState(false);
  const [isFromBOAtoXero, setIsFromBOAtoXero] = useState(true);
  const [isXeroLoading, setIsXeroLoading] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [selectAllAdd, setSelectAllAdd] = useState(true);
  const [selectAllUpdate, setSelectAllUpdate] = useState(true);
  const [isToAddOpen, setIsToAddOpen] = useState(true);
  const [isToUpdateOpen, setIsToUpdateOpen] = useState(true);
  const [confirmSync, setConfirmSync] = useState(false);

  const timeoutRef = useRef(null);

  const onExchangeSync = () => {
    setSyncWithXeroLoading(true);
    setIsClicked(true);
    setIsFromBOAtoXero(!isFromBOAtoXero);
    setSelectAllAdd(true);
    setSelectAllUpdate(true);
    setConfirmSync(false);
    setIsToAddOpen(true);
    setIsToUpdateOpen(true);

    setTimeout(() => {
      setIsClicked(false);
    }, 200);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setSyncWithXeroLoading(false);
    }, 1000);
  };

  const AnimatedIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    width: 20,
    height: 20,
    backgroundColor: "#f0f0f0",
    border: "2px solid #999",
    display: "inline-block",
    transition: "all 0.5s ease",
    position: "relative",
    boxSizing: "border-box",
    transform: "scale(1)",
    "input:hover ~ &": {
      borderColor: "#666",
    },
  }));

  const AnimatedCheckedIcon = styled(AnimatedIcon)(({ className }) => ({
    backgroundColor: isFromBOAtoXero ? "#00b6e3" : "#66cc23",
    borderColor: isFromBOAtoXero ? "#00b6e3" : "#66cc23",
    transform: "scale(1.1)", // little pop effect
    "input:hover ~ &": {
      borderColor: isFromBOAtoXero ? "#00b6e3" : "#66cc23",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: "4.5px",
      top: "1px",
      width: "6px",
      height: "12px",
      border: "solid white",
      borderWidth: "0 2px 2px 0",
      transform: "rotate(45deg)",
      animation: className === "pop-in" ? "popIn 0.2s ease-out" : "none",
    },
  }));

  const csvRef = useRef();
  const ref = useRef();
  const fileInputRef = useRef(null);

  const headers = [
    { key: "barcode", label: "SKU (required)" },
    { key: "description", label: "Description (max 50 chars)" },
    { key: "buyPrice", label: "BUY Price" },
    { key: "sellPrice", label: "SELL Price" },
    { key: "isDiscountApplied", label: "Apply Customer Discount (yes/1)" },
    { key: "notes", label: "Notes (max 500 chars)" },
    { key: "reason", label: "Reason" },
  ];

  const debouncedHandleChange = _debounce((value) => {
    getNonBOAProductsList(value);
    setSearchTerm(value);
  }, 500);

  const handleSearchChange = (event) => {
    const { value } = event.target;
    debouncedHandleChange(value);
  };

  const onNewNonNOAProduct = () => {
    setSelectedId(0);
    setNonBOAProductSaved(false);
    setFiles([]);
    const newData = {
      id: 0,
      barcode: "",
      description: "",
      buyPrice: null,
      sellPrice: null,
      isDiscountApplied: false,
      syncToXero: false,
      notes: "",
      fileUploads: [],
    };
    setFormData(newData);
  };

  function handleChange(dataType, value) {
    let newState = [];
    newState.push(formData);
    let data = newState.map((item, i) => {
      if (dataType === "barcode") {
        setHasBarcodeError(false);
        value = value.slice(0, 30);
      }
      if (dataType === "description") {
        value = value.slice(0, 50);
      }
      if (dataType === "notes") {
        value = value.slice(0, 500);
      }
      if (i == 0) {
        return { ...item, [dataType]: value };
      }
      return item;
    });

    setHasChanges(true);
    setFormData(data[0]);
  }

  const getNonBOAProductsList = async (keyword = "", isFirstLoad = false) => {
    setSearchLoading(true);
    const nonBOAProducts = await apiGetNonBOAProductsList(keyword);
    if (nonBOAProducts) {
      if (keyword === "") {
        const activeNonBOAProducts = nonBOAProducts.filter(
          (item) => item.id > 0
        );
        setNonBOAProducts(activeNonBOAProducts);
      }
      const UNASSIGNED_KEY = "Unassigned Contacts";
      const SPECIAL_KEY = "#";

      const groupedCompanies = nonBOAProducts.reduce((acc, company) => {
        const firstChar = company.barcode[0].toUpperCase();

        let groupKey;
        if (company.barcode === "Unassigned") {
          groupKey = UNASSIGNED_KEY;
        } else if (/[A-Z0-9]/.test(firstChar)) {
          groupKey = firstChar;
        } else {
          groupKey = SPECIAL_KEY;
        }

        acc[groupKey] = acc[groupKey] || [];
        acc[groupKey].push(company);
        return acc;
      }, {});

      // Remove "Unassigned Contacts" if the first object in its array has an empty nonBOAProductContacts array
      if (
        groupedCompanies[UNASSIGNED_KEY] &&
        groupedCompanies[UNASSIGNED_KEY][0].nonBOAProductContacts.length === 0
      ) {
        delete groupedCompanies[UNASSIGNED_KEY];
      }

      // Sort keys: Numbers (0-9), A-Z, then "#" (if it exists), then "Unassigned Contacts" (if it exists)
      const sortedKeys = Object.keys(groupedCompanies)
        .filter((key) => key !== SPECIAL_KEY && key !== UNASSIGNED_KEY)
        .sort((a, b) =>
          !isNaN(a) && isNaN(b)
            ? -1
            : isNaN(a) && !isNaN(b)
            ? 1
            : a.localeCompare(b)
        );

      // Add "#" if it has values
      if (groupedCompanies[SPECIAL_KEY]?.length) {
        sortedKeys.push(SPECIAL_KEY);
      }

      // Add "Unassigned Contacts" if it exists after filtering
      if (groupedCompanies[UNASSIGNED_KEY]) {
        sortedKeys.push(UNASSIGNED_KEY);
      }

      // Construct final sorted object
      const finalGroupedCompanies = sortedKeys.reduce((sortedAcc, key) => {
        sortedAcc[key] = groupedCompanies[key];
        return sortedAcc;
      }, {});

      const firstCategory = Object.keys(finalGroupedCompanies)[0];
      const firstNonBOAProduct = firstCategory
        ? finalGroupedCompanies[firstCategory][0]
        : null;

      if (firstNonBOAProduct && isFirstLoad) {
        setSelectedId(firstNonBOAProduct.id);
        setFormData(firstNonBOAProduct);
      }

      setNonBOAProductList(finalGroupedCompanies);
      setSearchLoading(false);
    } else {
      showErrorToast("Something went wrong");
      setSearchLoading(false);
    }
  };

  const getNonBOAProductData = async (
    id = null,
    data = null,
    onEdit = false
  ) => {
    setDataLoading(true);
    const result = data
      ? data
      : await apiGetNonBOAProduct(id ? id : selectedId);
    if (result) {
      const nonBOAProductData = {
        id: result.id,
        barcode: result.barcode,
        description: result.description,
        buyPrice: result.buyPrice
          ? result.buyPrice.toFixed(2)
          : result.buyPrice === 0
          ? 0
          : "",
        sellPrice: result.sellPrice
          ? result.sellPrice.toFixed(2)
          : result.sellPrice === 0
          ? 0
          : "",
        isDiscountApplied: result.isDiscountApplied,
        syncToXero: result.isSyncedToXero,
        notes: result.notes,
        fileUploads: result.fileUploads,
        isSyncedToXero: result.isSyncedToXero,
      };
      setOnNonBOAProductEdit(onEdit);
      setFormData(nonBOAProductData);
      setFiles(
        nonBOAProductData.fileUploads ? nonBOAProductData.fileUploads : []
      );
      setDataLoading(false);
      setHasChanges(false);
    } else {
      showErrorToast("Failed to load Non-BOA Item, please try again");
      setDataLoading(false);
    }
  };

  const onSubmitAddNonBOAProduct = async () => {
    setIsLoading(true);
    setNonBOAProductSaved(true);
    if (!formData.barcode || formData.barcode === "") {
      showErrorToast("SKU field is required");
      setIsLoading(false);
      return false;
    }
    try {
      const result = await apiAddNonBOAProduct(formData);
      if (result) {
        getNonBOAProductsList();
        getNonBOAProductData(result.id, result);
        setAddNonBOAItemOpen(false);
        setNonBOAProductSaved(true);
        showSuccessToast(
          <div>
            <i className="check icon" /> Non-BOA Item Added Successfully
          </div>
        );
        setIsLoading(false);
      } else {
        setHasBarcodeError(true);
        setIsLoading(false);
      }
    } catch (e) {
      showErrorToast("Something went wrong");
      setIsLoading(false);
    }
  };

  const onSubmitUpdateNonBOAProduct = async () => {
    setIsLoading(true);
    setNonBOAProductSaved(true);
    if (!formData.barcode || formData.barcode === "") {
      showErrorToast("SKU field is required");
      setIsLoading(false);
      return false;
    }

    const result = await apiUpdateNonBOAProduct(formData);
    if (result) {
      setNonBOAProductSaved(false);
      getNonBOAProductsList();
      getNonBOAProductData(result.id, result);
      showSuccessToast(
        <div>
          <i className="check icon" /> Non-BOA Item Updated Successfully
        </div>
      );
      setOnNonBOAProductEdit(false);
      setIsLoading(false);
    } else {
      setHasBarcodeError(true);
      setIsLoading(false);
    }
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
  };

  const onDeleteNonBOAProduct = async (includeContacts) => {
    setIsLoading(true);
    try {
      const nonBOAProductData = await apiDeleteNonBOAProduct(
        selectedNonBOAProduct.id
      );
      if (nonBOAProductData) {
        getNonBOAProductsList();
        showSuccessToast(
          <div>
            <i className="check icon" /> Non-BOA Item Deleted Successfully
          </div>
        );
        setSelectedNonBOAProduct({});
        setFormData({});
        setOpenRemoveNonBOAProduct(false);
        setOpenDeleteNonBOAProduct(false);
        setIsLoading(false);
      } else {
        showErrorToast("Something went wrong");
      }
    } catch {
      showErrorToast("Something went wrong");
      setIsLoading(false);
    }
  };

  // Function to filter objects based on the given model
  const filterObject = (obj, model) => {
    return Object.keys(model).reduce((acc, key) => {
      if (Array.isArray(model[key]) && Array.isArray(obj[key])) {
        // Recursively filter arrays of objects
        acc[key] = obj[key].map((item) => filterObject(item, model[key][0]));
      } else if (obj[key] !== undefined) {
        // Keep only keys present in the model
        acc[key] = obj[key];
      }
      return acc;
    }, {});
  };

  useEffect(() => {
    if (selectedId != "") {
      getNonBOAProductData();
    }
  }, [selectedId]);

  useEffect(() => {
    console.log(formData);
  }, [formData]);

  useEffect(() => {
    if (syncWithXeroOpen) {
      getSyncWithXeroList();
    }
  }, [syncWithXeroOpen]);

  useEffect(() => {
    syncWithXeroList.fromBOAtoXero?.toCreate?.map((item, i) => {
      item.isSelected = true;
    });
    syncWithXeroList.fromBOAtoXero?.toUpdate?.map((item, i) => {
      item.isSelected = true;
    });
    syncWithXeroList.fromXeroToBOA?.toCreate?.map((item, i) => {
      item.isSelected = true;
    });
    syncWithXeroList.fromXeroToBOA?.toUpdate?.map((item, i) => {
      item.isSelected = true;
    });
    if (isFromBOAtoXero) {
      setToCreateList(syncWithXeroList?.fromBOAtoXero?.toCreate);
      setToUpdateList(syncWithXeroList?.fromBOAtoXero?.toUpdate);
    } else {
      setToCreateList(syncWithXeroList?.fromXeroToBOA?.toCreate);
      setToUpdateList(syncWithXeroList?.fromXeroToBOA?.toUpdate);
    }
  }, [isFromBOAtoXero]);

  useEffect(() => {
    const accountType = localStorage.getItem("accountType");
    const userType = localStorage.getItem("userType");
    if (localStorage.getItem("isBoahubPremium") !== "true") {
      props.history.push("/");
    }

    const delayDebounceFn = setTimeout(async () => {
      getNonBOAProductsList("", true);
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, []);

  const NumericInputChecker = (event, decimalPlaces = 2) => {
    const { key, target } = event;
    const inputValue = target.value;
    console.log(inputValue);

    // Check if there is already a decimal point
    const hasDecimal = inputValue.includes(".");
    const decimalIndex = inputValue.indexOf(".");
    const isAfterDecimal =
      decimalIndex !== -1 && target.selectionStart > decimalIndex;
    const digitsAfterDecimal = isAfterDecimal
      ? inputValue.slice(decimalIndex + 1).length
      : 0;

    // Allow control keys like Backspace, Delete, and Arrow keys
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];

    // Handle input conditions
    if (
      // Allow numeric keys (0-9) if they don't exceed the allowed decimal places
      (!isNaN(key) &&
        (!isAfterDecimal || digitsAfterDecimal < decimalPlaces)) ||
      // Allow essential control keys
      allowedKeys.includes(key) ||
      // Allow one decimal point
      (key === "." && !hasDecimal)
    ) {
      return; // Allow input if conditions are met
    }

    // Prevent all other keys
    event.preventDefault();
  };

  const handleFileButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    setFilesLoading(true);
    const file = e.target.files[0];
    if (file) {
      console.log(file.size);
      if (file.size >= 5000000) {
        showErrorToast("File size cannot exceed 5MB.");
        setIsLoading(false);
        setFilesLoading(false);
        return false;
      }
      if (!formData?.id) {
        let list = [];
        list = files;
        list.push(file);
        setFiles(list);
        setFilesLoading(false);
        return false;
      }
      setIsLoading(true);
      try {
        const result = await apiNonBOAProductUploadFile(file, formData.id);
        if (result) {
          handleChange(
            "fileUploads",
            result.fileUploads ? result.fileUploads : []
          );
          setFiles(result.fileUploads ? result.fileUploads : []);
          setIsLoading(false);
          setFilesLoading(false);
          showSuccessToast(
            <div>
              <i className="check icon" /> File Uploaded Successfully
            </div>
          );
        } else {
          setIsLoading(false);
          setFilesLoading(false);
        }
      } catch {
        showErrorToast("Something went wrong");
        setIsLoading(false);
        setFilesLoading(false);
      }
    } else {
      setFilesLoading(false);
    }
  };

  const onDeleteFile = async () => {
    setIsLoading(true);

    const result = await apiNonBOAProductDeleteFile(
      selectedFile.id,
      formData.id
    );
    if (result) {
      showSuccessToast(
        <div>
          <i className="check icon" /> File Deleted Successfully
        </div>
      );
      setDeleteFileOpen(false);
      handleChange("fileUploads", result.fileUploads ? result.fileUploads : []);
      setFiles(result.fileUploads ? result.fileUploads : []);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const handleDownload = (file) => {
    window.open(file.fileUrl, "_blank");
  };

  function isNumber(value) {
    return !isNaN(value) && value.trim() !== "";
  }

  // Error checker for number fields
  function hasError(quantity) {
    let hasError = false;

    if (!quantity || quantity === "" || quantity === null) return false;
    if (isNaN(quantity)) {
      hasError = true;
    }
    if (!Number.isFinite(Number(parseFloat(quantity)))) {
      hasError = true;
    }
    if (quantity < 0) {
      hasError = true;
    }
    return hasError;
  }

  // Error checker for char limit
  function hasLimitError(value, limit) {
    if (value === "" || value === null) return false;
    if (value?.length > limit) return true;

    return false;
  }

  const generateCSV = () => {
    let csvContent = [
      [
        "SKU (required)",
        "Description (max 50 chars)",
        "BUY Price",
        "SELL Price",
        "Apply Customer Discount (yes/1)",
        "Notes (max 500 chars)",
      ],
      // Add more data rows here
    ];

    if (localStorage.getItem("boahubShowPurchasePrice") !== "true")
      csvContent[0] = csvContent[0].filter((str) => str !== "BUY Price");
    if (localStorage.getItem("boahubShowRrp") !== "true")
      csvContent[0] = csvContent[0].filter((str) => str !== "SELL Price");

    console.log(csvContent);

    const csvRows = csvContent.map((row) => row.join(",")); // Join each row with a comma

    return csvRows.join("\n"); // Join rows with a newline character
  };

  const handleBulkFileChange = (event) => {
    setIsLoading(true);
    const file = event.target.files[0];
    if (file) {
      setJsonResult([]);
      setJsonResultData([]);
      setHasImportError(false);
      Papa.parse(file, {
        complete: (result) => {
          let resultData = result.data.filter((row) => {
            // Check if at least one value in the row is not empty
            return Object.values(row).some(
              (value) => value && value.toString().trim() !== ""
            );
          });

          resultData.map(async (product) => {
            product.barcode = product["SKU (required)"];
            product.description = product["Description (max 50 chars)"];
            product.buyPrice = product["BUY Price"];
            product.sellPrice = product["SELL Price"];
            product.isDiscountApplied =
              product["Apply Customer Discount (yes/1)"];
            product.notes = product["Notes (max 500 chars)"];
          });

          resultData.map(async (product) => {
            product.barcode = product.barcode ? product.barcode.trim() : "";
            product.description = product.description
              ? product.description
              : "";
            product.buyPrice = product.buyPrice;
            product.sellPrice = product.sellPrice;
            product.isDiscountApplied = product.isDiscountApplied
              ? product.isDiscountApplied
              : "";
            product.notes = product.notes ? product.notes : "";
          });

          // Handle decimals for customer specific fields
          resultData.map((obj) => {
            obj.buyPrice = isNumber(obj.buyPrice)
              ? parseFloat(obj.buyPrice).toFixed(2)
              : obj.buyPrice;
            obj.sellPrice = isNumber(obj.sellPrice)
              ? parseFloat(obj.sellPrice).toFixed(2)
              : obj.sellPrice;
            obj.isDiscountApplied =
              obj.isDiscountApplied?.trim().toLowerCase() === "yes" ||
              obj.isDiscountApplied === "1"
                ? true
                : false;
          });

          const updatedData = addDuplicateFlag(resultData, "barcode");

          setJsonResultData(updatedData);
          setJsonResult(updatedData);

          // Validate imported csv file for data errors
          let errorCount = 0;
          updatedData.map((data) => {
            if (localStorage.getItem("boahubShowPurchasePrice") === "true")
              if (hasError(data.buyPrice)) errorCount++;
            if (localStorage.getItem("boahubShowRrp") === "true")
              if (hasError(data.sellPrice)) errorCount++;
            if (hasLimitError(data.barcode, 30)) errorCount++;
            if (hasLimitError(data.description, 50)) errorCount++;
            if (hasLimitError(data.notes, 500)) errorCount++;
          });
          if (errorCount > 0) {
            setHasImportError(true);
          }
          let hasDataError = false;
          updatedData.map((data) => {
            if (!data.barcode || data.hasDuplicate) {
              hasDataError = true;
            }
          });
          if (hasDataError) {
            setHasImportError(true);
          }

          setTimeout(() => {
            setIsLoading(false);
          }, 1000);
        },
        header: true, // Set this to true if your CSV file has headers
      });
    }
  };

  const addDuplicateFlag = (arr, key) => {
    // Step 1: Count how many times each value appears
    const counts = arr.reduce((acc, item) => {
      const value = item[key];
      acc[value] = (acc[value] || 0) + 1;
      return acc;
    }, {});

    // Step 2: Add `hasDuplicate: true` if the value appears more than once
    return arr.map((item) => ({
      ...item,
      hasDuplicate: counts[item[key]] > 1,
    }));
  };

  const onSaveNonBOAProducts = async () => {
    // Validate all payload data for errors
    let errorCount = 0;
    jsonResult.map((data) => {
      if (hasError(data.buyPrice)) errorCount++;
      if (hasError(data.sellPrice)) errorCount++;
    });
    if (errorCount > 0) {
      return false;
    }
    let hasDataError = false;
    jsonResult.map((data) => {
      if (!data.barcode || data.hasDuplicate) {
        setJsonResult(jsonResult);
        setJsonResultData(jsonResult);
        hasDataError = true;
      }
    });
    if (hasDataError) {
      return false;
    }

    setIsImporting(true);
    try {
      const data = await apiSaveNonBOAProductsBulk(jsonResultData);
      if (data) {
        if (
          data.rejectedNonBOAProducts &&
          data.rejectedNonBOAProducts?.length > 0
        ) {
          if (data.rejectedNonBOAProducts?.length === jsonResult.length) {
            showErrorToast("Non-BOA Items Import Failed.");
          } else {
            showSuccessToast(
              <div>
                <i className="check icon" />
                Non-BOA Items Imported Successfully with Errors: Some records
                were not imported.
              </div>
            );
          }
          setJsonResult(data.rejectedNonBOAProducts);
          setJsonResultData(data.rejectedNonBOAProducts);
          setFailedImports(data.rejectedNonBOAProducts);
          setIsImporting(false);
          return false;
        }
        getNonBOAProductsList();
        showSuccessToast(
          <div>
            <i className="check icon" /> Non-BOA Items Imported Successfully
          </div>
        );
        setTimeout(() => {
          setIsImporting(false);
          setCsvUploadOpen(false);
        }, 1500);
      } else {
        setIsImporting(false);
      }
    } catch {
      showErrorToast("Something went wrong");
      setIsImporting(false);
    }
  };

  const convertToCSV = (array, headers) => {
    let csvRows = [];
    let csvContent = headers;

    if (localStorage.getItem("boahubShowPurchasePrice") !== "true")
      csvContent = csvContent.filter((item) => item.label !== "BUY Price");
    if (localStorage.getItem("boahubShowRrp") !== "true")
      csvContent = csvContent.filter((item) => item.label !== "SELL Price");

    array.map((item) => {
      item.isDiscountApplied = item.isDiscountApplied ? "yes" : "no";
    });

    // Add custom header row
    csvRows.push(csvContent.map((h) => h.label).join(","));

    // Add data rows
    for (const row of array) {
      const values = csvContent.map((h) => `"${row[h.key] ?? ""}"`);
      csvRows.push(values.join(","));
    }

    return csvRows.join("\n");
  };

  const downloadCSV = (csvContent) => {
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.setAttribute("download", "failed-non-boa-items.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setCsvUploadOpen(false);
  };

  const getSyncWithXeroList = async () => {
    setIsLoading(true);
    setIsXeroLoading(true);
    try {
      const result = await apiGetSyncWithXeroList();
      if (result) {
        result.fromBOAtoXero?.toCreate?.map((item, i) => {
          item.isSelected = true;
        });
        result.fromBOAtoXero?.toUpdate?.map((item, i) => {
          item.isSelected = true;
        });
        result.fromXeroToBOA?.toCreate?.map((item, i) => {
          item.isSelected = true;
        });
        result.fromXeroToBOA?.toUpdate?.map((item, i) => {
          item.isSelected = true;
        });

        setSyncWithXeroList(result);
        if (isFromBOAtoXero) {
          setToCreateList(result.fromBOAtoXero?.toCreate);
          setToUpdateList(result.fromBOAtoXero?.toUpdate);
        } else {
          setToCreateList(result.fromXeroToBOA?.toCreate);
          setToUpdateList(result.fromXeroToBOA?.toUpdate);
        }
        setIsLoading(false);
        setIsXeroLoading(false);
      } else {
        showErrorToast("Something went wrong");
        setIsLoading(false);
        setIsXeroLoading(false);
      }
    } catch {
      showErrorToast("Something went wrong");
      setIsLoading(false);
      setIsXeroLoading(false);
    }
  };

  const onSelectAllAddProducts = async (selectAll) => {
    setSelectAllAdd(selectAll);
    let newList = toCreateList.map((item, i) => {
      item.isSelected = selectAll;
      return item;
    });
    setToCreateList(newList);
  };

  const onSelectAllUpdateProducts = async (selectAll) => {
    setSelectAllUpdate(selectAll);
    let newList = toUpdateList.map((item, i) => {
      item.isSelected = selectAll;
      return item;
    });
    setToUpdateList(newList);
  };

  function handleAddSelect(index, value) {
    console.log(value);
    let newList = toCreateList;
    let toAddListData = newList.map((item, i) => {
      if (i === index) {
        item.isSelected = value;
      }
      return item;
    });

    setToCreateList(toAddListData);
  }

  function handleUpdateSelect(index, checked) {
    let newList = toUpdateList;
    let toUpdateListData = newList.map((item, i) => {
      if (i === index) {
        item.isSelected = checked;
      }
      return item;
    });

    setToUpdateList(toUpdateListData);
  }

  const onSyncWithXero = async () => {
    setIsLoading(true);
    try {
      const selectedToCreateList = toCreateList.filter(
        (obj) => obj.isSelected === true
      );
      const selectedToUpdateList = toUpdateList.filter(
        (obj) => obj.isSelected === true
      );
      const data = await apiSyncWithXero(
        isFromBOAtoXero,
        selectedToCreateList,
        selectedToUpdateList
      );
      if (data) {
        getNonBOAProductsList();
        showSuccessToast(
          <div>
            <i className="check icon" />{" "}
            {`${data.totalCreated}/${data.totalToCreate} items created, ${data.totalUpdated}/${data.totalToUpdate} items updated.`}
          </div>
        );
        setTimeout(() => {
          setIsLoading(false);
          setSyncWithXeroOpen(false);
        }, 1500);
      } else {
        getNonBOAProductsList();
        showErrorToast("Something went wrong");
        setIsLoading(false);
      }
    } catch {
      getNonBOAProductsList();
      showErrorToast("Something went wrong");
      setIsLoading(false);
    }
  };

  const onSyncToXero = async () => {
    setIsLoading(true);
    setNonBOAProductSaved(true);

    formData.syncToXero = true;
    const result = await apiUpdateNonBOAProduct(formData);
    if (result) {
      setNonBOAProductSaved(false);
      getNonBOAProductsList();
      getNonBOAProductData(result.id, result);
      showSuccessToast(
        <div>
          <i className="check icon" /> Non-BOA Item Synced to Xero Successfully
        </div>
      );
      setOnNonBOAProductEdit(false);
      setIsLoading(false);
      setSyncToXeroOpen(false);
    } else {
      setHasBarcodeError(true);
      setIsLoading(false);
      setSyncToXeroOpen(false);
    }
  };

  const nonBOAProductListGrouped = Object.entries(nonBOAProductList)?.map(
    ([category, list], index) => (
      <div style={{ marginTop: index === 0 ? 0 : 32 }}>
        <span
          style={{
            fontSize: 18,
            marginLeft: 0,
            fontWeight: "bolder",
            color: "#66CC23",
          }}
        >
          {category}
        </span>
        <Grid columns={3}>
          {list?.map((data, i) => {
            return (
              <Grid.Column
                style={{ paddingTop: 10, paddingBottom: 0, paddingRight: 5 }}
              >
                <Card
                  className={
                    selectedId === data?.id ? "job-card active" : "job-card"
                  }
                  style={{
                    zIndex: 1,
                    marginTop: 10,
                    cursor: "default",
                    minWidth: 305,
                    minHeight: 125,
                    borderRadius: 10,
                    marginBottom: "0px !important",
                    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.3)",
                    position: "relative", // Ensure relative positioning
                    cursor: "pointer",
                    overflow: "hidden",
                    paddingLeft: 0,
                  }}
                >
                  <Card.Content
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (selectedId !== data?.id) {
                        setSelectedId(data.id);
                      } else {
                        setSelectedId("");
                        setFormData({});
                      }
                    }}
                  >
                    {localStorage.getItem("isXeroConnected") !==
                    "true" ? null : (
                      <>
                        {data.isSyncedToXero ? (
                          <img
                            src={syncedXeroIcon}
                            style={{
                              position: "absolute",
                              top: 13,
                              right: 9,
                              maxWidth: 25,
                              maxHeight: 25,
                              marginRight:
                                localStorage.getItem("userType") !== "4" &&
                                data.isDiscountApplied
                                  ? 30
                                  : "auto",
                            }}
                          />
                        ) : (
                          <>
                            {localStorage.getItem("userType") !== "4" ? (
                              <img
                                src={unsyncedXeroIcon}
                                style={{
                                  position: "absolute",
                                  top: 13,
                                  right: 9,
                                  maxWidth: 25,
                                  maxHeight: 25,
                                  marginRight:
                                    localStorage.getItem("userType") !== "4" &&
                                    data.isDiscountApplied
                                      ? 30
                                      : "auto",
                                }}
                              />
                            ) : null}
                          </>
                        )}
                      </>
                    )}
                    {localStorage.getItem("userType") !== "4" ? (
                      <>
                        {data.isDiscountApplied ? (
                          <Icon
                            style={{
                              position: "absolute",
                              top: 10,
                              right: 9,
                              fontSize: 18,
                              color: "#66CC23",
                            }}
                            link
                            name="tags"
                          />
                        ) : null}
                        {data.id !== -1 ? (
                          <Icon
                            style={{
                              zIndex: 2,
                              position: "absolute",
                              bottom: 13,
                              right: 13,
                              marginRight: 0,
                              color: "#ef0e0e",
                            }}
                            link
                            name="trash"
                            onClick={(e) => {
                              handleDeleteClick(e);
                              setSelectedNonBOAProduct(data);
                              setOpenRemoveNonBOAProduct(true);
                            }}
                          />
                        ) : null}
                      </>
                    ) : null}
                    <Grid columns={2} className="job-management">
                      <Grid.Row style={{ paddingTop: 0, paddingBottom: 8 }}>
                        <Grid.Column
                          width={data.isSyncedToXero ? 12 : 9}
                          style={{ paddingTop: 10, paddingRight: 5 }}
                        >
                          {/* <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <b>
                              <span
                                style={{ fontSize: 15, fontWeight: "bolder" }}
                              >
                                {data.barcode}
                              </span>
                            </b>
                          </div> */}
                        </Grid.Column>
                        <Grid.Column
                          width={data.isSyncedToXero ? 4 : 7}
                          style={{
                            paddingLeft: 0,
                            paddingTop: 8,
                            paddingBottom: 0,
                            paddingRight: 15,
                            textAlign: "right",
                          }}
                        ></Grid.Column>
                        <Grid.Column
                          width={16}
                          style={{
                            paddingTop: 30,
                            paddingRight: 5,
                          }}
                        >
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <b>
                              <span
                                style={{ fontSize: 16, fontWeight: "bolder" }}
                              >
                                {data.barcode}
                              </span>
                            </b>
                          </div>
                        </Grid.Column>
                        <Grid.Column
                          width={16}
                          style={{
                            paddingTop: 3,
                            paddingBottom: 0,
                            minHeight: 27,
                            paddingRight: 45,
                          }}
                        >
                          <span
                            style={{
                              fontSize: 13,
                              color: "rgba(140, 140, 140, 1)",
                            }}
                          >
                            {data.description}
                          </span>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Card.Content>
                </Card>
              </Grid.Column>
            );
          })}
        </Grid>
      </div>
    )
  );

  return (
    <React.Fragment>
      <MetaData title="Non-BOA Items" />
      <Modal
        size="tiny"
        open={addNonBOAItemOpen}
        style={{ marginTop: "-270px" }}
      >
        <Modal.Header>Create Non-BOA Item</Modal.Header>
        <div style={{ position: "absolute", top: 200, left: 242 }}>
          {isLoading ? (
            <Loader
              active
              className="workaround"
              size="large"
              inline="centered"
            />
          ) : null}
        </div>
        <Modal.Content
          style={{
            opacity: isLoading ? 0.2 : 1,
            pointerEvents: isLoading ? "none" : "",
          }}
        >
          <Form size="tiny" style={{ fontSize: 14 }}>
            <Grid style={{ minHeight: 200 }} disabled>
              <div
                className="nonBOAProduct-form-content"
                style={{
                  paddingRight: "0px !important",
                }}
              >
                <Form size="tiny">
                  <Grid disabled={!onNonBOAProductEdit}>
                    <Grid.Row style={{ paddingBottom: 0, paddingTop: 25 }}>
                      <Grid.Column width={16} style={{ paddingBottom: 15 }}>
                        <Form.Field required>
                          <label>SKU</label>
                          {formData?.barcode?.length >= 30 && (
                            <div
                              style={{
                                position: "absolute",
                                top: -3,
                                left: 53,
                              }}
                            >
                              <span
                                style={{ fontWeight: "normal", fontSize: 12 }}
                              >
                                (Max 30 characters)
                              </span>
                            </div>
                          )}
                          <Input
                            className={
                              (formData?.barcode === "" ||
                                formData?.barcode === null ||
                                !formData?.barcode) &&
                              nonBOAProductSaved
                                ? "error"
                                : hasBarcodeError
                                ? "error"
                                : ""
                            }
                            value={formData?.barcode}
                            onChange={(e, data) =>
                              handleChange("barcode", data.value)
                            }
                          />
                        </Form.Field>
                      </Grid.Column>
                      <Grid.Column
                        width={16}
                        style={{
                          paddingBottom: 15,
                        }}
                      >
                        <Form.Field>
                          <label>Description</label>
                          {formData?.description?.length >= 50 && (
                            <div
                              style={{
                                position: "absolute",
                                top: -3,
                                left: 87,
                              }}
                            >
                              <span
                                style={{ fontWeight: "normal", fontSize: 12 }}
                              >
                                (Max 50 characters)
                              </span>
                            </div>
                          )}
                          <Input
                            value={formData?.description}
                            onChange={(e, data) =>
                              handleChange("description", data.value)
                            }
                          />
                        </Form.Field>
                      </Grid.Column>
                      <Grid.Column width={16}>
                        <Grid>
                          {localStorage.getItem("boahubShowRrp") === "true" && (
                            <Grid.Column width={8}>
                              <Form.Field>
                                <label>Sell Price</label>
                                {!dataLoading ? (
                                  <Input
                                    defaultValue={formData?.sellPrice}
                                    onBlur={(e) =>
                                      handleChange("sellPrice", e.target.value)
                                    }
                                    onKeyDown={(event) =>
                                      NumericInputChecker(event, 2)
                                    }
                                  />
                                ) : (
                                  <Input disabled />
                                )}
                              </Form.Field>
                            </Grid.Column>
                          )}
                          {localStorage.getItem("boahubShowPurchasePrice") ===
                            "true" && (
                            <Grid.Column width={8}>
                              <Form.Field>
                                <label>Buy Price</label>
                                {!dataLoading ? (
                                  <Input
                                    defaultValue={formData?.buyPrice}
                                    onBlur={(e) =>
                                      handleChange("buyPrice", e.target.value)
                                    }
                                    onKeyDown={(event) =>
                                      NumericInputChecker(event, 2)
                                    }
                                  />
                                ) : (
                                  <Input disabled />
                                )}
                              </Form.Field>
                            </Grid.Column>
                          )}
                        </Grid>
                      </Grid.Column>
                      <Grid.Column width={8} style={{ paddingTop: 22 }}>
                        <Form.Field>
                          <label>Apply Customer Discount</label>
                        </Form.Field>
                      </Grid.Column>
                      <Grid.Column
                        width={8}
                        style={{
                          paddingTop: 21,
                          textAlign: "right",
                          paddingLeft: 0,
                        }}
                      >
                        <Checkbox
                          className="small-toggle"
                          style={{ marginTop: -1 }}
                          toggle
                          checked={formData.isDiscountApplied}
                          onChange={(e, data) =>
                            handleChange("isDiscountApplied", data.checked)
                          }
                        />
                      </Grid.Column>
                      {localStorage.getItem("isXeroConnected") === "true" ? (
                        <>
                          <Grid.Column width={10} style={{ paddingTop: 7 }}>
                            <Form.Field>
                              <label>
                                Sync Non-BOA item to{" "}
                                <span style={{ color: "#00b6e3" }}>Xero</span>
                              </label>
                            </Form.Field>
                          </Grid.Column>
                          <Grid.Column
                            width={6}
                            style={{
                              paddingTop: 16,
                              textAlign: "right",
                              paddingLeft: 0,
                            }}
                          >
                            <style>
                              {`
                                /* Use a custom class to increase specificity */
                                .small-toggle-xero.ui.toggle.checkbox input:checked ~ .box:before,
                                .small-toggle-xero.ui.toggle.checkbox input:checked ~ label:before {
                                background-color: #00b6e3 !important; /* Pink toggle */
                                border-color: #00b6e3 !important;
                                }
                              `}
                            </style>
                            <Checkbox
                              className="small-toggle-xero"
                              style={{ marginTop: -11 }}
                              toggle
                              checked={formData.syncToXero}
                              onChange={(e, data) =>
                                handleChange("syncToXero", data.checked)
                              }
                            />
                          </Grid.Column>
                        </>
                      ) : null}
                      <Grid.Column width={16} style={{ paddingTop: 10 }}>
                        <div>
                          <span
                            style={{
                              position: "absolute",
                              top: 13,
                              right: 20,
                              fontSize: 12,
                              color: "#AFABAB",
                            }}
                          >
                            Maximum 500 characters
                          </span>
                        </div>
                        <Form.Field>
                          <label>Notes</label>
                          <TextareaAutosize
                            onChange={(e) =>
                              handleChange("notes", e.target.value)
                            }
                            value={formData?.notes}
                            style={{ minHeight: 50 }}
                          />
                        </Form.Field>
                        <div>
                          <span
                            style={{
                              position: "absolute",
                              bottom: -6,
                              right: 20,
                              fontSize: 12,
                              color: "#AFABAB",
                            }}
                          >
                            {formData?.notes?.length
                              ? formData?.notes?.length
                              : 0}
                            /500 characters
                          </span>
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Form>
              </div>
            </Grid>
            <Grid style={{ marginTop: 50 }}>
              <Grid.Column width={8} style={{ paddingRight: 5 }}>
                <Button
                  size="tiny"
                  style={{
                    width: "100%",
                    marginLeft: "auto",
                  }}
                  onClick={() => {
                    setAddNonBOAItemOpen(false);
                  }}
                >
                  CANCEL
                </Button>
              </Grid.Column>
              <Grid.Column width={8} style={{ paddingLeft: 5 }}>
                <Button
                  size="tiny"
                  style={{
                    width: "100%",
                    backgroundColor: "rgb(102, 204, 35)",
                    color: "#fff",
                    marginLeft: "auto",
                  }}
                  onClick={() => {
                    onSubmitAddNonBOAProduct();
                  }}
                >
                  SAVE
                </Button>
              </Grid.Column>
            </Grid>
          </Form>
        </Modal.Content>
      </Modal>
      <Modal
        size="mini"
        open={openRemoveNonBOAProduct}
        onClose={() => setOpenRemoveNonBOAProduct(false)}
      >
        <div style={{ position: "absolute", bottom: 100, left: 150 }}>
          {isLoading ? (
            <Loader
              active
              className="workaround"
              size="large"
              inline="centered"
            />
          ) : null}
        </div>
        <Modal.Content
          style={{ opacity: isLoading ? 0.2 : 1, textAlign: "center" }}
        >
          <p>
            Are you sure <br /> you want to delete this Non-BOA Item?
            <br />
            <br />
            {selectedNonBOAProduct.barcode}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpenRemoveNonBOAProduct(false)}>NO</Button>
          <Button
            style={{
              backgroundColor: "rgb(102, 204, 35)",
              color: "#fff",
            }}
            onClick={() => {
              onDeleteNonBOAProduct(false);
            }}
          >
            YES
          </Button>
        </Modal.Actions>
      </Modal>
      <Modal
        size="mini"
        open={openDeleteNonBOAProduct}
        onClose={() => setOpenDeleteNonBOAProduct(false)}
      >
        <div style={{ position: "absolute", bottom: 100, left: 150 }}>
          {isLoading ? (
            <Loader
              active
              className="workaround"
              size="large"
              inline="centered"
            />
          ) : null}
        </div>
        <Modal.Content
          style={{ opacity: isLoading ? 0.2 : 1, textAlign: "center" }}
        >
          <p>
            Do you want to delete all contacts <br />
            attached to {selectedNonBOAProduct.barcode}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpenDeleteNonBOAProduct(false)}>
            CANCEL
          </Button>
          <Button onClick={() => onDeleteNonBOAProduct(false)}>NO</Button>
          <Button
            style={{
              backgroundColor: "rgb(102, 204, 35)",
              color: "#fff",
            }}
            onClick={() => onDeleteNonBOAProduct(true)}
          >
            YES
          </Button>
        </Modal.Actions>
      </Modal>
      <Modal
        size="mini"
        open={openRemoveContact}
        onClose={() => setOpenRemoveContact(false)}
      >
        <div style={{ position: "absolute", bottom: 100, left: 150 }}>
          {isLoading ? (
            <Loader
              active
              className="workaround"
              size="large"
              inline="centered"
            />
          ) : null}
        </div>
        <Modal.Content
          style={{ opacity: isLoading ? 0.2 : 1, textAlign: "center" }}
        >
          <p>
            Are you sure <br /> you want to delete contact?
            <br />
            <br />
            {selectedContact.contactName}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpenRemoveContact(false)}>NO</Button>
          <Button
            style={{
              backgroundColor: "rgb(102, 204, 35)",
              color: "#fff",
            }}
            // onClick={() => onDeleteContact()}
          >
            YES
          </Button>
        </Modal.Actions>
      </Modal>
      <Modal
        className="non-boa-bulk-upload-modal"
        open={csvUploadOpen}
        onClose={() => setCsvUploadOpen(false)}
      >
        <Modal.Header>Bulk Upload of Non-BOA Items</Modal.Header>
        <Modal.Content>
          <Grid style={{ margin: 0 }}>
            <Grid.Column
              width={16}
              style={{
                minHeight: 400,
                maxHeight: 400,
                overflowY: "auto",
              }}
            >
              {jsonResult.length > 0 ? (
                <Table sortable celled fixed>
                  <Table.Header
                    style={{ fontSize: 12, paddingLeft: 0, paddingRight: 0 }}
                  >
                    <Table.Row>
                      <Table.HeaderCell textAlign="center">
                        SKU
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="center" width={3}>
                        Description
                      </Table.HeaderCell>
                      {localStorage.getItem("boahubShowPurchasePrice") ===
                        "true" && (
                        <Table.HeaderCell textAlign="center">
                          BUY Price
                        </Table.HeaderCell>
                      )}
                      {localStorage.getItem("boahubShowRrp") === "true" && (
                        <Table.HeaderCell textAlign="center">
                          Sell Price
                        </Table.HeaderCell>
                      )}
                      <Table.HeaderCell textAlign="center">
                        Apply Customer Discount
                      </Table.HeaderCell>
                      <Table.HeaderCell
                        textAlign="center"
                        width={failedImports.length > 0 ? 2 : 3}
                      >
                        Notes
                      </Table.HeaderCell>
                      {failedImports.length > 0 ? (
                        <Table.HeaderCell textAlign="center" width={4}>
                          Reason
                        </Table.HeaderCell>
                      ) : null}
                    </Table.Row>
                  </Table.Header>
                  <Table.Body style={{ fontSize: 13 }}>
                    {jsonResult.map(
                      ({
                        barcode,
                        description,
                        buyPrice,
                        sellPrice,
                        isDiscountApplied,
                        notes,
                        reason,
                        hasDuplicate,
                      }) => (
                        <Table.Row key={barcode}>
                          <Table.Cell
                            textAlign="center"
                            style={{
                              border:
                                !barcode ||
                                hasDuplicate ||
                                hasLimitError(barcode, 30)
                                  ? "solid 1px red"
                                  : "",
                            }}
                          >
                            {!barcode ? (
                              <Popup
                                content={"Customer Name is required"}
                                trigger={
                                  <div
                                    style={{ width: "100%", height: "100%" }}
                                  >
                                    {barcode ? barcode : <span>&nbsp;</span>}
                                  </div>
                                }
                                position="top center"
                                inverted
                              />
                            ) : hasDuplicate ? (
                              <Popup
                                content={`SKU ${barcode} is duplicated`}
                                trigger={
                                  <div
                                    style={{ width: "100%", height: "100%" }}
                                  >
                                    {barcode ? barcode : <span>&nbsp;</span>}
                                  </div>
                                }
                                position="top center"
                                inverted
                              />
                            ) : hasLimitError(barcode, 30) ? (
                              <Popup
                                content={`Max. 30 characters allowed`}
                                trigger={
                                  <div
                                    style={{ width: "100%", height: "100%" }}
                                  >
                                    {barcode ? barcode : <span>&nbsp;</span>}
                                  </div>
                                }
                                position="top center"
                                inverted
                              />
                            ) : (
                              barcode
                            )}
                          </Table.Cell>
                          <Table.Cell
                            textAlign="center"
                            style={{
                              border: hasLimitError(description, 50)
                                ? "solid 1px red"
                                : "",
                            }}
                          >
                            <div
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {hasLimitError(description, 50) ? (
                                <Popup
                                  content={`Max. 50 characters allowed`}
                                  trigger={
                                    <div
                                      style={{ width: "100%", height: "100%" }}
                                    >
                                      {description ? (
                                        description
                                      ) : (
                                        <span>&nbsp;</span>
                                      )}
                                    </div>
                                  }
                                  position="top center"
                                  inverted
                                />
                              ) : (
                                description
                              )}
                            </div>
                          </Table.Cell>
                          {localStorage.getItem("boahubShowPurchasePrice") ===
                            "true" && (
                            <Table.Cell
                              textAlign="center"
                              style={{
                                border: hasError(buyPrice)
                                  ? "solid 2.5px red"
                                  : "",
                              }}
                            >
                              {!Number.isFinite(
                                Number(parseFloat(buyPrice))
                              ) ? (
                                <Popup
                                  content={"BUY Price must be a number"}
                                  trigger={<div>{buyPrice}</div>}
                                  position="top center"
                                  inverted
                                  style={{ textAlign: "center" }}
                                />
                              ) : isNaN(buyPrice) ? (
                                <Popup
                                  content={"BUY Price must be a number"}
                                  trigger={<div>{buyPrice}</div>}
                                  position="top center"
                                  inverted
                                  style={{ textAlign: "center" }}
                                />
                              ) : buyPrice < 0 ? (
                                <Popup
                                  content={"BUY Price can't be negative"}
                                  trigger={<div>{buyPrice}</div>}
                                  position="top center"
                                  inverted
                                  style={{ textAlign: "center" }}
                                />
                              ) : (
                                buyPrice
                              )}
                            </Table.Cell>
                          )}
                          {localStorage.getItem("boahubShowRrp") === "true" && (
                            <Table.Cell
                              textAlign="center"
                              style={{
                                border: hasError(sellPrice)
                                  ? "solid 2.5px red"
                                  : "",
                              }}
                            >
                              {!Number.isFinite(
                                Number(parseFloat(sellPrice))
                              ) ? (
                                <Popup
                                  content={"SELL Price must be a number"}
                                  trigger={<div>{sellPrice}</div>}
                                  position="top center"
                                  inverted
                                  style={{ textAlign: "center" }}
                                />
                              ) : isNaN(sellPrice) ? (
                                <Popup
                                  content={"SELL Price must be a number"}
                                  trigger={<div>{sellPrice}</div>}
                                  position="top center"
                                  inverted
                                  style={{ textAlign: "center" }}
                                />
                              ) : sellPrice < 0 ? (
                                <Popup
                                  content={"SELL Price can't be negative"}
                                  trigger={<div>{sellPrice}</div>}
                                  position="top center"
                                  inverted
                                  style={{ textAlign: "center" }}
                                />
                              ) : (
                                sellPrice
                              )}
                            </Table.Cell>
                          )}
                          <Table.Cell
                            textAlign="center"
                            style={{ paddingTop: 15 }}
                          >
                            <Checkbox
                              className="non-boa-checkbox"
                              checked={isDiscountApplied}
                              style={{ cursor: "default" }}
                            />
                          </Table.Cell>
                          <Table.Cell
                            textAlign="center"
                            style={{
                              border: hasLimitError(notes, 500)
                                ? "solid 1px red"
                                : "",
                            }}
                          >
                            <div
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {hasLimitError(notes, 500) ? (
                                <Popup
                                  content={`Max. 50 characters allowed`}
                                  trigger={
                                    <div
                                      style={{ width: "100%", height: "100%" }}
                                    >
                                      {notes ? notes : <span>&nbsp;</span>}
                                    </div>
                                  }
                                  position="top center"
                                  inverted
                                />
                              ) : (
                                notes
                              )}
                            </div>
                          </Table.Cell>
                          {failedImports.length > 0 ? (
                            <Table.Cell
                              textAlign="center"
                              style={{
                                border: "solid 2.5px red",
                              }}
                            >
                              {reason}
                            </Table.Cell>
                          ) : null}
                        </Table.Row>
                      )
                    )}
                  </Table.Body>
                </Table>
              ) : (
                <div
                  style={{
                    paddingTop: 70,
                    width: 450,
                    marginLeft: "auto",
                    marginRight: "auto",
                    fontSize: 22,
                    color: "#AFABAB",
                    lineHeight: 2.5,
                  }}
                >
                  <span>1. Download template for Bulk Upload as CSV</span>
                  <br />
                  <span>2. Edit the CSV file locally</span>
                  <br />
                  <span>3. Upload the CSV file for preview</span>
                </div>
              )}
            </Grid.Column>
            <Grid.Column width={5} style={{ paddingRight: 5 }}>
              {failedImports.length > 0 ? null : (
                <Button
                  disabled={isLoading}
                  size="tiny"
                  onClick={() => {
                    const csvData = generateCSV();
                    const blob = new Blob([csvData], { type: "text/csv" });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "non-boa-items-bulk-upload-template.csv";
                    a.click();
                    URL.revokeObjectURL(url);
                  }}
                >
                  DOWNLOAD TEMPLATE
                </Button>
              )}
            </Grid.Column>
            {failedImports.length > 0 ? (
              <Grid.Column
                width={11}
                style={{ paddingLeft: 5, textAlign: "right" }}
              >
                <Button
                  disabled={isLoading}
                  size="tiny"
                  color="youtube"
                  onClick={() => {
                    setCsvUploadOpen(false);
                    setJsonResult([]);
                  }}
                  style={{ marginRight: 10, width: 130 }}
                >
                  IGNORE
                </Button>
                <Button
                  disabled={isLoading}
                  size="tiny"
                  onClick={() => {
                    const csv = convertToCSV(jsonResult, headers);
                    downloadCSV(csv);
                  }}
                >
                  REDOWNLOAD FILE
                </Button>
              </Grid.Column>
            ) : (
              <Grid.Column
                width={11}
                style={{ paddingLeft: 5, textAlign: "right" }}
              >
                <Button
                  disabled={isLoading}
                  size="tiny"
                  color="youtube"
                  onClick={() => {
                    setCsvUploadOpen(false);
                    setJsonResult([]);
                  }}
                  style={{ marginRight: 10 }}
                >
                  CANCEL
                </Button>
                <Button
                  disabled={isLoading}
                  size="tiny"
                  onClick={() => csvRef.current.click()}
                >
                  LOAD NEW FILE
                </Button>
                {!isLoading ? (
                  <input
                    ref={csvRef}
                    type="file"
                    hidden
                    onChange={handleBulkFileChange}
                    accept=".csv"
                  />
                ) : null}
                {hasImportError ? (
                  <Popup
                    content={"Please correct all data before importing"}
                    trigger={
                      <Button
                        size="tiny"
                        style={{
                          backgroundColor: "rgb(102, 204, 35)",
                          color: "#fff",
                          marginLeft: 8,
                          opacity: 0.6,
                          cursor: "not-allowed",
                        }}
                        onClick={() => onSaveNonBOAProducts()}
                      >
                        {!isImporting ? "IMPORT" : "IMPORTING..."}
                      </Button>
                    }
                    position="top center"
                    inverted
                    style={{ textAlign: "center" }}
                  />
                ) : (
                  <Button
                    disabled={jsonResult.length === 0 || isLoading}
                    size="tiny"
                    style={{
                      backgroundColor: "rgb(102, 204, 35)",
                      color: "#fff",
                      marginLeft: 8,
                    }}
                    onClick={() => onSaveNonBOAProducts()}
                  >
                    {!isImporting ? "IMPORT" : "IMPORTING..."}
                  </Button>
                )}
              </Grid.Column>
            )}
          </Grid>
        </Modal.Content>
      </Modal>
      <Modal size="mini" open={deleteFileOpen}>
        <div style={{ position: "absolute", bottom: 100, left: 150 }}>
          {isLoading ? (
            <Loader
              active
              className="workaround"
              size="large"
              inline="centered"
            />
          ) : null}
        </div>
        <Modal.Content
          style={{ opacity: isLoading ? 0.2 : 1, textAlign: "center" }}
        >
          <p>
            Are you sure <br /> you want to delete file?
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setDeleteFileOpen(false)}>NO</Button>
          <Button
            style={{
              backgroundColor: "rgb(102, 204, 35)",
              color: "#fff",
            }}
            onClick={() => onDeleteFile()}
          >
            YES
          </Button>
        </Modal.Actions>
      </Modal>
      <Modal
        size="mini"
        open={syncToXeroOpen}
        onClose={() => setSyncToXeroOpen(false)}
      >
        <div style={{ position: "absolute", bottom: 100, left: 150 }}>
          {isLoading ? (
            <Loader
              active
              className="workaround"
              size="large"
              inline="centered"
            />
          ) : null}
        </div>
        <Modal.Content
          style={{ opacity: isLoading ? 0.2 : 1, textAlign: "center" }}
        >
          <p>
            Are you sure you want to export
            <br /> this item to <span style={{ color: "#00b6e3" }}>Xero</span>
            <br />
            <br />
            {selectedNonBOAProduct.barcode}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setSyncToXeroOpen(false)}>NO</Button>
          <Button
            style={{
              backgroundColor: "rgb(102, 204, 35)",
              color: "#fff",
            }}
            onClick={() => {
              setIsLoading(true);
              handleChange("syncToXero", true);
              setTimeout(() => {
                onSyncToXero();
              }, 500);
            }}
          >
            YES
          </Button>
        </Modal.Actions>
      </Modal>
      <Modal className="xero-sync-modal" open={syncWithXeroOpen}>
        <Modal.Header
          style={{
            backgroundColor: isFromBOAtoXero ? "#00b6e3" : "#66cc23",
            transition: "background-color 0.5s ease",
          }}
        >
          <div style={{ paddingTop: 5 }}>
            <span style={{ fontSize: 24 }}>Sync Non-BOA Items With Xero</span>
          </div>
        </Modal.Header>
        <Modal.Content>
          {isLoading ? (
            <Dimmer active inverted>
              <Loader size="large"></Loader>
            </Dimmer>
          ) : null}
          <div
            style={{
              minHeight: 500,
              maxHeight: 500,
              overflowX: "hidden",
              overflowY: "auto",
            }}
          >
            <Grid style={{ paddingTop: 10, paddingBottom: 0 }}>
              <Grid.Column width={3}></Grid.Column>
              <Grid.Column
                width={2}
                style={{ textAlign: "right", paddingTop: 30 }}
              >
                <div style={{ marginRight: -25 }}>
                  <span style={{ fontSize: 18, fontWeight: "bold" }}>FROM</span>
                </div>
              </Grid.Column>
              <Grid.Column width={2} style={{ paddingRight: 0 }}>
                <div
                  className="switch-wrapper switch-from"
                  style={{
                    transform: isFromBOAtoXero
                      ? "translateX(0px)"
                      : "translateX(137px)", // moves toward "TO"
                    transition: "transform 0.4s ease-in-out",
                    marginLeft: "auto",
                  }}
                >
                  <Image
                    style={{
                      width: 50,
                      height: 50,
                      marginLeft: "auto",
                    }}
                    src={boaRoundIcon}
                  />
                </div>
              </Grid.Column>
              <Grid.Column width={2} style={{ paddingTop: 20 }}>
                <Image
                  style={{
                    width: 40,
                    height: 40,
                    marginLeft: "auto",
                    marginRight: "auto",
                    transition: "transform 0.5s ease",
                    transform: isClicked
                      ? "scale(1.2)"
                      : isHovered
                      ? "scale(1.1)"
                      : "scale(1)",
                    cursor: "pointer",
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  onClick={() => onExchangeSync()}
                  src={exchangeIcon}
                />
              </Grid.Column>
              <Grid.Column width={2} style={{ paddingLeft: 0 }}>
                <div
                  className="switch-wrapper switch-to"
                  style={{
                    transform: isFromBOAtoXero
                      ? "translateX(0px)"
                      : "translateX(-137px)", // moves toward "FROM"
                    transition: "transform 0.4s ease-in-out",
                  }}
                >
                  <Image
                    style={{
                      width: 50,
                      height: 50,
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                    src={xeroRoundIcon}
                  />
                </div>
              </Grid.Column>
              <Grid.Column width={2} style={{ paddingTop: 30 }}>
                <div style={{ marginLeft: -25 }}>
                  <span style={{ fontSize: 18, fontWeight: "bold" }}>TO</span>
                </div>
              </Grid.Column>
              <Grid.Column width={3}></Grid.Column>
            </Grid>
            <Grid style={{ paddingTop: 0 }}>
              <Grid.Column width={16} style={{ paddingBottom: 0 }}>
                <Collapsible
                  open={isToAddOpen}
                  handleTriggerClick={() => setIsToAddOpen(!isToAddOpen)}
                  style={{ zIndex: 1 }}
                  trigger={
                    <div>
                      <RoundCheckbox
                        checked={selectAllAdd}
                        onChange={() =>
                          onSelectAllAddProducts(
                            toCreateList?.some(
                              (item) => item.isSelected === true
                            )
                              ? false
                              : true
                          )
                        }
                        style={{
                          zIndex: 2,
                          position: "absolute",
                          top: 8.5,
                          right: 44,
                          marginRight: 0,
                        }}
                        icon={<AnimatedIcon />}
                        checkedIcon={<AnimatedCheckedIcon />}
                        sx={{ padding: "6px" }}
                        onClick={handleDeleteClick}
                      />
                      <Grid style={{ padding: 0 }}>
                        <Grid.Column width={9}>
                          <div
                            style={{
                              backgroundColor:
                                isToAddOpen && isFromBOAtoXero
                                  ? "#00b6e3"
                                  : isToAddOpen && !isFromBOAtoXero
                                  ? "#66cc23"
                                  : "transparent",
                              marginLeft: -20,
                              marginBottom: -3,
                              paddingLeft: 20,
                              paddingBottom: 3,
                              borderTopRightRadius: 30,
                              borderBottomRightRadius: 30,
                            }}
                          >
                            <span
                              style={{
                                fontSize: 20,
                                color: isToAddOpen
                                  ? "#fff"
                                  : isFromBOAtoXero
                                  ? "#00b6e3"
                                  : "#66cc23",
                              }}
                            >
                              Items to Add in{" "}
                              {isFromBOAtoXero ? "Xero" : "BOAhub"}
                            </span>
                          </div>
                        </Grid.Column>
                        <Grid.Column width={3} style={{ paddingTop: 20 }}>
                          <span
                            style={{
                              fontSize: 13,
                              fontWeight: "bolder",
                              color: "#000",
                            }}
                          >
                            {
                              toCreateList?.filter(
                                (obj) => obj.isSelected === true
                              ).length
                            }{" "}
                            Selected
                          </span>
                        </Grid.Column>
                        <Grid.Column
                          width={3}
                          style={{
                            paddingTop: 20,
                            textAlign: "center",
                            paddingLeft: 0,
                            paddingRight: 22,
                          }}
                        >
                          <span
                            style={{
                              fontSize: 13,
                              fontWeight: "bolder",
                              color: "#000",
                            }}
                          >
                            {toCreateList?.some(
                              (item) => item.isSelected === true
                            )
                              ? "Unselect all"
                              : "Select all"}
                          </span>
                        </Grid.Column>
                        <Grid.Column width={1}></Grid.Column>
                      </Grid>
                      {!isToAddOpen && (
                        <hr
                          style={{
                            backgroundColor: isFromBOAtoXero
                              ? "#00b6e3"
                              : "#66cc23",
                            marginTop: 0,
                            marginRight: 0,
                          }}
                        />
                      )}
                    </div>
                  }
                >
                  <div
                    style={{
                      minHeight: 0,
                      paddingTop: 10,
                      paddingBottom: 5,
                      width: "100%",
                    }}
                  >
                    <Grid>
                      {syncWithXeroLoading ? null : (
                        <Grid.Column
                          width={16}
                          style={{
                            padding: "0px 17px",
                          }}
                        >
                          {toCreateList?.map((item, index) => {
                            return (
                              <div key={index}>
                                <Card
                                  className={
                                    item.isSelected && isFromBOAtoXero
                                      ? "xero-list-card-xero"
                                      : item.isSelected && !isFromBOAtoXero
                                      ? "xero-list-card"
                                      : ""
                                  }
                                  style={{
                                    width: "96.24%",
                                    minHeight: 62,
                                    marginBottom: 12,
                                    cursor: "pointer",
                                  }}
                                >
                                  <Card.Content>
                                    <RoundCheckbox
                                      key={index}
                                      style={{
                                        zIndex: 2,
                                        position: "absolute",
                                        top: 3,
                                        right: 5,
                                        marginRight: 0,
                                      }}
                                      icon={<AnimatedIcon />}
                                      checkedIcon={<AnimatedCheckedIcon />}
                                      sx={{ padding: "6px" }}
                                      onChange={(e, value) => {
                                        handleAddSelect(index, value);
                                      }}
                                      checked={item.isSelected}
                                    />
                                    <Grid>
                                      <Grid.Column
                                        width={8}
                                        style={{
                                          paddingLeft: 10,
                                          paddingRight: 0,
                                          paddingTop: 7,
                                          paddingBottom: 0,
                                        }}
                                      >
                                        <Button
                                          style={{
                                            backgroundColor: "#fff",
                                            border: "1px solid #808080",
                                            padding: 3,
                                            fontSize: 16,
                                            marginTop: -3,
                                            color: "#000",
                                          }}
                                        >
                                          {`${item.barcode}`}
                                        </Button>
                                      </Grid.Column>
                                      <Grid.Column
                                        width={4}
                                        style={{
                                          paddingTop: 7,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                        }}
                                      >
                                        {localStorage.getItem(
                                          "boahubShowRrp"
                                        ) === "true" && (
                                          <span
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: 13,
                                              color: "rgba(0, 0, 0, 0.69)",
                                            }}
                                          >
                                            Sell Price:{" "}
                                            {formatPrice(item.sellPrice)}
                                          </span>
                                        )}
                                      </Grid.Column>
                                      <Grid.Column
                                        width={4}
                                        style={{
                                          paddingTop: 7,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                        }}
                                      >
                                        {localStorage.getItem(
                                          "boahubShowPurchasePrice"
                                        ) === "true" && (
                                          <span
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: 13,
                                              color: "rgba(0, 0, 0, 0.69)",
                                            }}
                                          >
                                            Buy Price:{" "}
                                            {formatPrice(item.buyPrice)}
                                          </span>
                                        )}
                                      </Grid.Column>
                                      <Grid.Column
                                        width={16}
                                        style={{
                                          paddingLeft: 11.5,
                                          paddingTop: 2,
                                          paddingBottom: 5,
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: 13,
                                            color: "#8C8C8C",
                                          }}
                                        >
                                          {`${item.description}`}
                                        </span>
                                      </Grid.Column>
                                    </Grid>
                                  </Card.Content>
                                </Card>
                              </div>
                            );
                          })}
                        </Grid.Column>
                      )}
                    </Grid>
                  </div>
                </Collapsible>
              </Grid.Column>
              <Grid.Column width={16} style={{ paddingTop: 15 }}>
                <Collapsible
                  open={isToUpdateOpen}
                  handleTriggerClick={() => setIsToUpdateOpen(!isToUpdateOpen)}
                  style={{ zIndex: 1 }}
                  trigger={
                    <div>
                      <RoundCheckbox
                        checked={selectAllUpdate}
                        onChange={() =>
                          onSelectAllUpdateProducts(
                            toUpdateList?.some(
                              (item) => item.isSelected === true
                            )
                              ? false
                              : true
                          )
                        }
                        style={{
                          zIndex: 2,
                          position: "absolute",
                          top: 8.5,
                          right: 44,
                          marginRight: 0,
                        }}
                        icon={<AnimatedIcon />}
                        checkedIcon={<AnimatedCheckedIcon />}
                        sx={{ padding: "6px" }}
                        onClick={handleDeleteClick}
                      />
                      <Grid style={{ padding: 0 }}>
                        <Grid.Column width={9}>
                          <div
                            style={{
                              backgroundColor:
                                isToUpdateOpen && isFromBOAtoXero
                                  ? "#00b6e3"
                                  : isToUpdateOpen && !isFromBOAtoXero
                                  ? "#66cc23"
                                  : "transparent",
                              marginLeft: -20,
                              marginBottom: -3,
                              paddingLeft: 20,
                              paddingBottom: 3,
                              borderTopRightRadius: 30,
                              borderBottomRightRadius: 30,
                            }}
                          >
                            <span
                              style={{
                                fontSize: 20,
                                color: isToUpdateOpen
                                  ? "#fff"
                                  : isFromBOAtoXero
                                  ? "#00b6e3"
                                  : "#66cc23",
                              }}
                            >
                              Items to Update in{" "}
                              {isFromBOAtoXero ? "Xero" : "BOAhub"}
                            </span>
                          </div>
                        </Grid.Column>
                        <Grid.Column width={3} style={{ paddingTop: 20 }}>
                          <span
                            style={{
                              fontSize: 13,
                              fontWeight: "bolder",
                              color: "#000",
                            }}
                          >
                            {
                              toUpdateList?.filter(
                                (obj) => obj.isSelected === true
                              ).length
                            }{" "}
                            Selected
                          </span>
                        </Grid.Column>
                        <Grid.Column
                          width={3}
                          style={{
                            paddingTop: 20,
                            textAlign: "center",
                            paddingLeft: 0,
                            paddingRight: 22,
                          }}
                        >
                          <span
                            style={{
                              fontSize: 13,
                              fontWeight: "bolder",
                              color: "#000",
                            }}
                          >
                            {toUpdateList?.some(
                              (item) => item.isSelected === true
                            )
                              ? "Unselect all"
                              : "Select all"}
                          </span>
                        </Grid.Column>
                        <Grid.Column width={1}></Grid.Column>
                      </Grid>
                      {!isToUpdateOpen && (
                        <hr
                          style={{
                            backgroundColor: isFromBOAtoXero
                              ? "#00b6e3"
                              : "#66cc23",
                            marginTop: 0,
                            marginRight: 0,
                          }}
                        />
                      )}
                    </div>
                  }
                >
                  <div
                    style={{
                      minHeight: 60,
                      paddingTop: 10,
                      paddingBottom: 25,
                      width: "100%",
                    }}
                  >
                    <Grid>
                      {syncWithXeroLoading ? null : (
                        <Grid.Column
                          width={16}
                          style={{
                            padding: "0px 17px",
                          }}
                        >
                          {toUpdateList?.map((item, index) => {
                            return (
                              <div key={index}>
                                <Card
                                  className={
                                    item.isSelected && isFromBOAtoXero
                                      ? "xero-list-card-xero"
                                      : item.isSelected && !isFromBOAtoXero
                                      ? "xero-list-card"
                                      : ""
                                  }
                                  style={{
                                    width: "96.24%",
                                    minHeight: 62,
                                    marginBottom: 12,
                                    cursor: "pointer",
                                  }}
                                >
                                  <Card.Content>
                                    <RoundCheckbox
                                      key={index}
                                      style={{
                                        zIndex: 2,
                                        position: "absolute",
                                        top: 3,
                                        right: 5,
                                        marginRight: 0,
                                      }}
                                      icon={<AnimatedIcon />}
                                      checkedIcon={<AnimatedCheckedIcon />}
                                      sx={{ padding: "6px" }}
                                      onChange={(e, value) => {
                                        handleUpdateSelect(index, value);
                                      }}
                                      checked={item.isSelected}
                                    />
                                    <Grid>
                                      <Grid.Column
                                        width={8}
                                        style={{
                                          paddingLeft: 10,
                                          paddingRight: 0,
                                          paddingTop: 7,
                                          paddingBottom: 0,
                                        }}
                                      >
                                        <Button
                                          style={{
                                            backgroundColor: "#fff",
                                            border: "1px solid #808080",
                                            padding: 3,
                                            fontSize: 16,
                                            marginTop: -3,
                                            color: "#000",
                                          }}
                                        >
                                          {`${item.barcode}`}
                                        </Button>
                                      </Grid.Column>
                                      <Grid.Column
                                        width={4}
                                        style={{
                                          paddingTop: 7,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                        }}
                                      >
                                        {localStorage.getItem(
                                          "boahubShowRrp"
                                        ) === "true" && (
                                          <span
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: 13,
                                              color: "rgba(0, 0, 0, 0.69)",
                                            }}
                                          >
                                            Sell Price:{" "}
                                            {formatPrice(item.sellPrice)}
                                          </span>
                                        )}
                                      </Grid.Column>
                                      <Grid.Column
                                        width={4}
                                        style={{
                                          paddingTop: 7,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                        }}
                                      >
                                        {localStorage.getItem(
                                          "boahubShowPurchasePrice"
                                        ) === "true" && (
                                          <span
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: 13,
                                              color: "rgba(0, 0, 0, 0.69)",
                                            }}
                                          >
                                            Buy Price:{" "}
                                            {formatPrice(item.buyPrice)}
                                          </span>
                                        )}
                                      </Grid.Column>
                                      <Grid.Column
                                        width={16}
                                        style={{
                                          paddingLeft: 11.5,
                                          paddingTop: 2,
                                          paddingBottom: 5,
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: 13,
                                            color: "#8C8C8C",
                                          }}
                                        >
                                          {`${item.description}`}
                                        </span>
                                      </Grid.Column>
                                    </Grid>
                                  </Card.Content>
                                </Card>
                              </div>
                            );
                          })}
                        </Grid.Column>
                      )}
                    </Grid>
                  </div>
                </Collapsible>
              </Grid.Column>
            </Grid>
          </div>
          <div>
            <Grid style={{ marginTop: 50 }}>
              <Grid.Column width={1} style={{ paddingTop: 21 }}>
                <RoundCheckbox
                  checked={confirmSync}
                  icon={<AnimatedIcon />}
                  checkedIcon={<AnimatedCheckedIcon />}
                  sx={{ padding: "6px" }}
                  onClick={() => setConfirmSync(!confirmSync)}
                />
              </Grid.Column>
              <Grid.Column width={7} style={{ paddingLeft: 3 }}>
                <span style={{ color: "red" }}>*</span>{" "}
                <span>
                  I acknowledge that syncing will overwrite the selected items
                  details in
                </span>{" "}
                <span
                  style={{ color: isFromBOAtoXero ? "#00b6e3" : "#66cc23" }}
                >
                  {isFromBOAtoXero ? "Xero" : "BOAhub"}
                </span>
              </Grid.Column>
              <Grid.Column
                width={4}
                style={{ paddingRight: 5, paddingTop: 22 }}
              >
                <Button
                  size="tiny"
                  style={{
                    width: "100%",
                    marginLeft: "auto",
                  }}
                  onClick={() => {
                    setSyncWithXeroOpen(false);
                    getNonBOAProductsList();
                    setIsFromBOAtoXero(true);
                    setConfirmSync(false);
                    setIsToAddOpen(true);
                    setIsToUpdateOpen(true);
                  }}
                >
                  DISCARD
                </Button>
              </Grid.Column>
              <Grid.Column width={4} style={{ paddingLeft: 5, paddingTop: 22 }}>
                <Button
                  disabled={!confirmSync}
                  size="tiny"
                  style={{
                    width: "100%",
                    backgroundColor: isFromBOAtoXero ? "#00b6e3" : "#66cc23",
                    transition: "background-color 0.5s ease",
                    color: "#fff",
                    marginLeft: "auto",
                  }}
                  onClick={() => onSyncWithXero()}
                >
                  CONFIRM & SYNC
                </Button>
              </Grid.Column>
            </Grid>
          </div>
        </Modal.Content>
      </Modal>
      <Grid
        columns={3}
        divided
        className="my-nonBOAProducts"
        style={{ marginTop: -30 }}
      >
        <Grid.Row style={{ paddingTop: 5, zIndex: 1 }}>
          <Grid.Column width={16} style={{ paddingRight: 0 }}>
            <h3 style={{ marginLeft: 20 }}>
              {/* <img
                src={myNonBOAProductsIcon}
                style={{
                  width: 30,
                  height: 30,
                  marginTop: -5,
                  marginRight: 8,
                }}
              /> */}
              Non-BOA Items
            </h3>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ paddingTop: 0, paddingBottom: 0 }}>
          <Grid.Column
            width={12}
            className="transfer-list-section"
            style={{ paddingRight: 0 }}
          >
            <Grid>
              <Grid.Column width={9}>
                <div style={{ paddingLeft: "1.2rem" }}>
                  <Input
                    icon="search"
                    placeholder="Search for your Non-BOA Items"
                    style={{ width: "100%" }}
                    size="mini"
                    onChange={handleSearchChange}
                  />
                </div>
              </Grid.Column>
              <Grid.Column width={7} style={{ paddingLeft: 0 }}>
                {localStorage.getItem("userType") !== "4" ? (
                  <div
                    className="job-actions"
                    style={{ textAlign: "right", paddingRight: 12 }}
                  >
                    <Button
                      className="default-status"
                      size="mini"
                      style={{
                        height: "100%",
                        minWidth: 130,
                        paddingLeft: 13,
                        paddingRight: 13,
                        marginRight: 10,
                      }}
                      onClick={() => {
                        setSelectedId(0);
                        setFormData({});
                        setJsonResult([]);
                        setJsonResultData([]);
                        setFailedImports([]);
                        setOnNonBOAProductEdit(false);
                        setCsvUploadOpen(true);
                        setHasImportError(false);
                      }}
                    >
                      Bulk Upload
                    </Button>
                    {localStorage.getItem("isXeroConnected") === "true" ? (
                      <Button
                        size="mini"
                        style={{
                          height: "100%",
                          minWidth: 130,
                          paddingLeft: 13,
                          paddingRight: 13,
                          marginRight: 10,
                          backgroundColor: "#00b6e3",
                          color: "#fff",
                        }}
                        onClick={() => {
                          setToCreateList([]);
                          setToUpdateList([]);
                          setSelectAllAdd(true);
                          setSelectAllUpdate(true);
                          setSyncWithXeroOpen(true);
                          setConfirmSync(false);
                          setIsFromBOAtoXero(true);
                          setIsToAddOpen(true);
                          setIsToUpdateOpen(true);
                        }}
                      >
                        Sync With Xero
                      </Button>
                    ) : null}
                    <Button
                      className="active-status"
                      size="mini"
                      style={{
                        height: "100%",
                        minWidth: 130,
                        paddingLeft: 13,
                        paddingRight: 13,
                      }}
                      onClick={() => {
                        onNewNonNOAProduct();
                        setOnNonBOAProductEdit(false);
                        setAddNonBOAItemOpen(true);
                      }}
                    >
                      <Icon name="add" style={{ color: "#fff" }} />
                      Create New
                    </Button>
                  </div>
                ) : null}
              </Grid.Column>
            </Grid>
            <hr />
            <div className="transfer-list">
              <div style={{ position: "absolute", top: 200, left: 350 }}>
                {searchLoading ? (
                  <Loader
                    active
                    className="workaround"
                    size="large"
                    inline="centered"
                  >
                    Loading Non-BOA Items...
                  </Loader>
                ) : null}
              </div>
              {!searchLoading &&
                Object.keys(nonBOAProductList).length === 0 && (
                  <div
                    style={{
                      textAlign: "center",
                      paddingTop: 100,
                      paddingRight: 20,
                      color: "#AFABAB",
                      fontSize: 19,
                    }}
                  >
                    <span>No Non-BOA Items Found</span>
                  </div>
                )}
              <div
                ref={ref}
                className="inventory-list-scroll"
                disabled={searchLoading}
                style={{ opacity: searchLoading ? 0.2 : 1, paddingTop: 5 }}
              >
                {nonBOAProductListGrouped}
              </div>
            </div>
          </Grid.Column>
          {!formData?.id ? (
            <Grid.Column width={4}></Grid.Column>
          ) : (
            <Grid.Column width={4} style={{ paddingRight: 0, paddingLeft: 12 }}>
              <Grid>
                <Grid.Column
                  width={16}
                  style={{
                    paddingLeft: 0,
                    paddingRight: "2rem",
                    paddingBottom: 30,
                    paddingTop: 17,
                  }}
                >
                  {formData?.id !== -1 ? (
                    <div className="job-actions" style={{ textAlign: "right" }}>
                      {!onNonBOAProductEdit ? (
                        <>
                          {localStorage.getItem("userType") !== "4" ? (
                            <Button
                              style={{
                                backgroundColor: "rgb(255, 173, 0)",
                                color: "#fff",
                                paddingLeft: 15,
                                paddingRight: 15,
                                minWidth: 130,
                              }}
                              size="mini"
                              onClick={() => setOnNonBOAProductEdit(true)}
                            >
                              Edit
                            </Button>
                          ) : null}
                        </>
                      ) : (
                        <>
                          <Button
                            className="active-status"
                            style={{
                              paddingLeft: 15,
                              paddingRight: 15,
                              minWidth: 130,
                            }}
                            size="mini"
                            onClick={() => {
                              onSubmitUpdateNonBOAProduct();
                            }}
                          >
                            Confirm
                          </Button>
                          <Button
                            className="default-status"
                            style={{
                              paddingLeft: 15,
                              paddingRight: 15,
                              minWidth: 130,
                            }}
                            size="mini"
                            onClick={() => {
                              if (hasChanges) getNonBOAProductData();
                              setOnNonBOAProductEdit(false);
                            }}
                          >
                            Cancel
                          </Button>
                        </>
                      )}
                    </div>
                  ) : null}
                </Grid.Column>
              </Grid>
              <div
                className="nonBOAProduct-form-content"
                style={{ paddingRight: "0px !important" }}
              >
                <Grid>
                  <Grid.Column width={16} style={{ paddingRight: 2 }}>
                    <div style={{ paddingTop: 5, paddingRight: 16 }}>
                      {!onNonBOAProductEdit ? (
                        <span
                          style={{
                            fontSize:
                              formData?.barcode?.length >= 25
                                ? 18
                                : formData?.barcode?.length >= 20
                                ? 24
                                : 20,
                            fontWeight: "bolder",
                          }}
                        >
                          {formData?.barcode}
                        </span>
                      ) : (
                        <Input
                          className={
                            (formData?.barcode === "" ||
                              formData?.barcode === null ||
                              !formData?.barcode) &&
                            nonBOAProductSaved
                              ? "nonBOAProduct-input error"
                              : hasBarcodeError
                              ? "nonBOAProduct-input error"
                              : "nonBOAProduct-input"
                          }
                          style={{ fontSize: 20, padding: 0, border: 0 }}
                          value={formData?.barcode}
                          onChange={(e, data) =>
                            handleChange("barcode", data.value)
                          }
                        />
                      )}
                    </div>
                    <hr />
                  </Grid.Column>
                </Grid>
                {dataLoading ? (
                  <div style={{ position: "absolute", top: 200, left: 140 }}>
                    <Loader
                      active
                      className="workaround"
                      size="large"
                      inline="centered"
                    />
                  </div>
                ) : (
                  <Form size="tiny">
                    <Grid disabled={!onNonBOAProductEdit}>
                      <Grid.Row style={{ paddingBottom: 0, paddingTop: 5 }}>
                        <Grid.Column
                          width={16}
                          style={{
                            paddingBottom: 15,
                          }}
                        >
                          <Form.Field>
                            <label>Description</label>
                            <Input
                              value={formData?.description}
                              onChange={(e, data) =>
                                handleChange("description", data.value)
                              }
                            />
                          </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={16}>
                          <Grid>
                            {localStorage.getItem("boahubShowRrp") ===
                              "true" && (
                              <Grid.Column width={8}>
                                <Form.Field>
                                  <label>Sell Price</label>
                                  {!dataLoading ? (
                                    <Input
                                      defaultValue={formData?.sellPrice}
                                      onBlur={(e) =>
                                        handleChange(
                                          "sellPrice",
                                          e.target.value
                                        )
                                      }
                                      onKeyDown={(event) =>
                                        NumericInputChecker(event, 2)
                                      }
                                    />
                                  ) : (
                                    <Input disabled />
                                  )}
                                </Form.Field>
                              </Grid.Column>
                            )}
                            {localStorage.getItem("boahubShowPurchasePrice") ===
                              "true" && (
                              <Grid.Column width={8}>
                                <Form.Field>
                                  <label>Buy Price</label>
                                  {!dataLoading ? (
                                    <Input
                                      defaultValue={formData?.buyPrice}
                                      onBlur={(e) =>
                                        handleChange("buyPrice", e.target.value)
                                      }
                                      onKeyDown={(event) =>
                                        NumericInputChecker(event, 2)
                                      }
                                    />
                                  ) : (
                                    <Input disabled />
                                  )}
                                </Form.Field>
                              </Grid.Column>
                            )}
                          </Grid>
                        </Grid.Column>
                        {localStorage.getItem("userType") !== "4" ? (
                          <>
                            <Grid.Column width={10} style={{ paddingTop: 17 }}>
                              <Form.Field>
                                <label>Apply Customer Discount</label>
                              </Form.Field>
                            </Grid.Column>
                            <Grid.Column
                              width={6}
                              style={{
                                paddingTop: 16,
                                textAlign: "right",
                                paddingLeft: 0,
                              }}
                            >
                              <Checkbox
                                className="small-toggle"
                                style={{ marginTop: -1 }}
                                toggle
                                checked={formData.isDiscountApplied}
                                onChange={(e, data) =>
                                  handleChange(
                                    "isDiscountApplied",
                                    data.checked
                                  )
                                }
                              />
                            </Grid.Column>
                            {formData?.isSyncedToXero ? null : localStorage.getItem(
                                "isXeroConnected"
                              ) === "true" ? (
                              <>
                                <Grid.Column
                                  width={10}
                                  style={{ paddingTop: 7 }}
                                >
                                  <Form.Field>
                                    <label>
                                      Sync Non-BOA item to{" "}
                                      <span style={{ color: "#00b6e3" }}>
                                        Xero
                                      </span>
                                    </label>
                                  </Form.Field>
                                </Grid.Column>
                                <Grid.Column
                                  width={6}
                                  style={{
                                    paddingTop: 16,
                                    textAlign: "right",
                                    paddingLeft: 0,
                                  }}
                                >
                                  <style>
                                    {`
                                      /* Use a custom class to increase specificity */
                                      .small-toggle-xero.ui.toggle.checkbox input:checked ~ .box:before,
                                      .small-toggle-xero.ui.toggle.checkbox input:checked ~ label:before {
                                      background-color: #00b6e3 !important; /* Pink toggle */
                                      border-color: #00b6e3 !important;
                                      }
                                    `}
                                  </style>
                                  <Checkbox
                                    className="small-toggle-xero"
                                    style={{ marginTop: -11 }}
                                    toggle
                                    checked={formData.syncToXero}
                                    onChange={(e, data) =>
                                      handleChange("syncToXero", data.checked)
                                    }
                                  />
                                </Grid.Column>
                              </>
                            ) : null}
                          </>
                        ) : null}
                        <Grid.Column width={16} style={{ paddingTop: 15 }}>
                          <div>
                            {onNonBOAProductEdit && (
                              <span
                                style={{
                                  position: "absolute",
                                  top: 17,
                                  right: 20,
                                  fontSize: 12,
                                  color: "#AFABAB",
                                }}
                              >
                                Maximum 500 characters
                              </span>
                            )}
                          </div>
                          <Form.Field>
                            <label>Notes</label>
                            <TextareaAutosize
                              onChange={(e) =>
                                handleChange("notes", e.target.value)
                              }
                              value={formData?.notes}
                              style={{ minHeight: 50 }}
                            />
                          </Form.Field>
                          <div>
                            {onNonBOAProductEdit && (
                              <span
                                style={{
                                  position: "absolute",
                                  bottom: -6,
                                  right: 20,
                                  fontSize: 12,
                                  color: "#AFABAB",
                                }}
                              >
                                {formData?.notes?.length
                                  ? formData?.notes?.length
                                  : 0}
                                /500 characters
                              </span>
                            )}
                          </div>
                        </Grid.Column>
                        <Grid.Column
                          width={11}
                          style={{ paddingTop: 10, paddingRight: 0 }}
                        >
                          <span
                            style={{
                              fontSize: 13,
                              fontWeight: "bold",
                            }}
                          >
                            Additional Files
                          </span>
                          <br />
                          {onNonBOAProductEdit && (
                            <span
                              style={{
                                fontSize: 11,
                                color: "#8C8C8C",
                              }}
                            >
                              JPG, PNG and PDF only. Maximum 4 files.
                            </span>
                          )}
                        </Grid.Column>
                        <Grid.Column
                          width={5}
                          style={{
                            paddingLeft: 0,
                            paddingTop: 25,
                            paddingRight: 0,
                            textAlign: "left",
                          }}
                        >
                          {localStorage.getItem("userType") !== "4" ? (
                            <>
                              <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                                accept=".jpg,.jpeg,.png,.pdf"
                              />
                              <Button
                                disabled={files.length > 3}
                                className={
                                  files.length > 3
                                    ? "default-status"
                                    : "active-status"
                                }
                                style={{
                                  marginTop: -20,
                                  marginLeft: 0,
                                  fontSize: 11,
                                }}
                                onClick={() => handleFileButtonClick()}
                              >
                                {filesLoading ? "Uploading..." : "Upload File"}
                              </Button>
                            </>
                          ) : null}
                        </Grid.Column>
                        <Grid.Column width={16} style={{ paddingRight: 0 }}>
                          <hr style={{ border: "1px solid #66CC23" }} />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                    <Grid>
                      <Grid.Column
                        width={16}
                        style={{
                          padding: 0,
                          paddingTop: 15,
                        }}
                      >
                        <Grid
                          style={{
                            marginLeft: "1.1rem",
                            paddingTop: 5,
                            paddingRight: 0,
                          }}
                        >
                          {files?.length > 0 ? (
                            <>
                              {files.map((data) => {
                                return (
                                  <Grid.Column
                                    width={16}
                                    style={{
                                      padding: 0,
                                      marginBottom: 10,
                                    }}
                                  >
                                    <Card
                                      key={data.Id}
                                      style={{
                                        cursor: "default",
                                        width: "90%",
                                      }}
                                    >
                                      <Card.Content
                                        style={{
                                          minHeight: 50,
                                          padding: 10,
                                        }}
                                      >
                                        <Card.Description
                                          style={{
                                            fontSize: 10,
                                            padding: 0,
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            handleDownload(data);
                                          }}
                                        >
                                          <Grid>
                                            <Grid.Column width={2}>
                                              <Icon
                                                name={
                                                  data.fileType === "DOC"
                                                    ? "file pdf outline"
                                                    : "file image outline"
                                                }
                                                style={{
                                                  fontSize: 20,
                                                  color:
                                                    data.fileType === "DOC"
                                                      ? "red"
                                                      : "#71A8D2",
                                                }}
                                              />
                                            </Grid.Column>
                                            <Grid.Column
                                              width={12}
                                              style={{
                                                paddingTop: 21,
                                                paddingLeft: 10,
                                                overflow: "auto",
                                                wordWrap: "break-word",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                }}
                                              >
                                                <span style={{ fontSize: 12 }}>
                                                  {data.fileName
                                                    ? data.fileName
                                                    : data.name}
                                                </span>
                                              </div>
                                            </Grid.Column>
                                          </Grid>
                                        </Card.Description>
                                        <Icon
                                          style={{
                                            visibility:
                                              formData?.id > 0 &&
                                              !onNonBOAProductEdit
                                                ? "hidden"
                                                : "visible",
                                            position: "absolute",
                                            top: 13,
                                            right: 13,
                                            marginRight: 0,
                                            color: "#ef0e0e",
                                          }}
                                          link
                                          name="trash"
                                          onClick={() => {
                                            setSelectefFile(data);
                                            setDeleteFileOpen(true);
                                          }}
                                        />
                                      </Card.Content>
                                    </Card>
                                  </Grid.Column>
                                );
                              })}
                            </>
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                textAlign: "center",
                                paddingTop: 20,
                                paddingRight: 50,
                                color: "#AFABAB",
                                fontSize: 16,
                              }}
                            >
                              <span>Edit Non-BOA item to add files</span>
                            </div>
                          )}
                        </Grid>
                      </Grid.Column>
                    </Grid>
                  </Form>
                )}
              </div>
            </Grid.Column>
          )}
        </Grid.Row>
      </Grid>
    </React.Fragment>
  );
};

export default NonBOAItems;
